import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import App from "../../app";
import { msalInstance, request } from "./msalConfig";
import NotAuthorized from "../../pages/noAuth";
import { Spin } from "antd";
import { setAppRoleHome, setEmailHome } from "../../slicers/homeTab.slicer";
import {
  setAppRoleNielsenPage,
  setEmailAddressNielsen,
} from "../../slicers/nielsenfilters.slicer";
import {
  setAppRoleEposPage,
  setEmailAddressEpos,
} from "../../slicers/eposfilters.slicer";

export const DEVMODE = true;

function CheckAuthorization(props) {
  const dispatch = useDispatch();
  const [loading, setloading] = useState(false);
  const [notAuth, setnotAuth] = useState(true);

  useEffect(() => {
    setloading(true);
    msalInstance
      .handleRedirectPromise()
      .then((tokenResponse) => {
        if (!tokenResponse) {
          const accounts = msalInstance.getAllAccounts();
          if (accounts.length === 0) {
            //user login for the first time
            msalInstance.loginRedirect();
          } else {
            //while refreshing
            sessionStorage.setItem("email", accounts[0].username);
            dispatch(setEmailHome(accounts[0].username));
            dispatch(setEmailAddressNielsen(accounts[0].username));
            dispatch(setEmailAddressEpos(accounts[0].username));
            const param = { ...request, ...{ account: {} } };
            msalInstance.acquireTokenSilent(param).then((res) => {
              if (res && res.accessToken)
                sessionStorage.setItem("token", res.accessToken);
              let app_role = res.idTokenClaims.roles;
              if (typeof app_role == "undefined") {
                setnotAuth(true);
              } else {
                setnotAuth(false);
                if (app_role.includes("Tool.Admin")) {
                  dispatch(setAppRoleHome("Tool.Admin"));
                  dispatch(setAppRoleNielsenPage("Tool.Admin"));
                  dispatch(setAppRoleEposPage("Tool.Admin"));
                } else if (app_role.includes("Read.AllDatasets")) {
                  dispatch(setAppRoleHome("Read.AllDatasets"));
                  dispatch(setAppRoleNielsenPage("Read.AllDatasets"));
                  dispatch(setAppRoleEposPage("Read.AllDatasets"));
                } else if (app_role.includes("Read.Nielsen")) {
                  dispatch(setAppRoleHome("Read.Nielsen"));
                  dispatch(setAppRoleNielsenPage("Read.Nielsen"));
                  dispatch(setAppRoleEposPage("Read.Nielsen"));
                } else {
                  dispatch(setAppRoleHome("Read.Epos"));
                  dispatch(setAppRoleNielsenPage("Read.Epos"));
                  dispatch(setAppRoleEposPage("Read.Epos"));
                }
              }
            });
          }
        } else {
          //logging in after session expiry
          const param = { ...request, ...{ account: tokenResponse.account } };
          msalInstance.acquireTokenSilent(param).then((res) => {
            if (res && res.accessToken)
              sessionStorage.setItem("token", res.accessToken);
            sessionStorage.setItem("email", tokenResponse.account.username);
            dispatch(setEmailHome(tokenResponse.account.username));
            dispatch(setEmailAddressNielsen(tokenResponse.account.username));
            dispatch(setEmailAddressEpos(tokenResponse.account.username));
            let app_role2 = res.idTokenClaims.roles;
            if (typeof app_role2 == "undefined") {
              setnotAuth(true);
            } else {
              setnotAuth(false);

              if (app_role2.includes("Tool.Admin")) {
                dispatch(setAppRoleHome("Tool.Admin"));
                dispatch(setAppRoleNielsenPage("Tool.Admin"));
                dispatch(setAppRoleEposPage("Tool.Admin"));
              } else if (app_role2.includes("Read.AllDatasets")) {
                dispatch(setAppRoleHome("Read.AllDatasets"));
                dispatch(setAppRoleNielsenPage("Read.AllDatasets"));
                dispatch(setAppRoleEposPage("Read.AllDatasets"));
              } else if (app_role2.includes("Read.Nielsen")) {
                dispatch(setAppRoleHome("Read.Nielsen"));
                dispatch(setAppRoleNielsenPage("Read.Nielsen"));
                dispatch(setAppRoleEposPage("Read.Nielsen"));
              } else {
                dispatch(setAppRoleHome("Read.Epos"));
                dispatch(setAppRoleNielsenPage("Read.Epos"));
                dispatch(setAppRoleEposPage("Read.Epos"));
              }
            }
          });
        }
      })
      .catch((err) => {
        setnotAuth(true);
      })
      .finally(() => {
        setloading(false);
      });
  }, []);

  return loading ? (
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translateX(-50%) translateY(-50%)",
      }}
    >
      <Spin />
    </div>
  ) : !notAuth ? (
    <App />
  ) : (
    <NotAuthorized />
  );
}

export default CheckAuthorization;
